// extracted by mini-css-extract-plugin
export default {"hr":"qRwho"};